import { useSaveContext } from "ra-core";
import { FC, ReactElement } from "react";
import { useSimpleSaveAction } from "./SaveContextProvider";
import { promiseWithResolvers } from "@/utils/promiseWithResolvers";


const WithSave : FC<{
  render: (x:{save:(record: any, callbacks?: any) => any, saving:boolean}) => ReactElement|null;
  async?: boolean;
}> = ({ render, async }) => {
  let save = useSimpleSaveAction()
  const { saving } = useSaveContext()
  if (async) {
    const raSave = save
    save = (x: any) => {
      const { promise, resolve, reject } = promiseWithResolvers()
      raSave(x, {
        onSuccess: (data: any) => {
          resolve(data.data) // dataProvider convension, payload always has similar type: {data:any}
        },
        onFailure: (err: any) => {
          reject(err)
        },
      })
      return promise
    }
  }
  return render({ save, saving: Boolean(saving) }) ?? <></>
}


export default WithSave;
